<template>
  <v-list-tile @click="open">
    <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'plus']"></font-awesome-icon></v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-title>語学資格を追加する</v-list-tile-title>
    </v-list-tile-content>
    <v-list-tile-action class="text-xs-right">
      <v-btn flat :disabled="true"></v-btn>
    </v-list-tile-action>
    <v-dialog scrollable v-model="config.status.active" max-width="600">
      <v-card>
        <v-card-title class="grey lighten-3 blue-grey--text text--darken-4">
          <span class="headline">語学資格の追加</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md class="pa-0">
            <v-form ref="form" v-model="form.valid" lazy-validation>
              <v-layout wrap>
                <v-flex xs12 class="px-3">
                  <v-combobox
                    v-model="form.name"
                    label="資格名"
                    :rules="rules.name"
                    :items="getCertItems"></v-combobox>
                </v-flex>
                <v-flex xs12 class="px-3">
                  <v-text-field
                    v-model="form.score"
                    label="点数・級"
                    :rules="rules.score"></v-text-field>
                </v-flex>
                <v-flex xs12 class="px-3">
                  <v-text-field
                    v-model="printFormatedDate"
                    maxlength="30"
                    append-icon="event"
                    @click:append="datepick"
                    label="取得時期"></v-text-field>
                  <v-dialog v-model="config.datepicker.date.status" max-width="290">
                    <v-date-picker
                      v-model="config.datepicker.date.data"
                      color="amber"
                      locale="ja"
                      :day-format="date => new Date(date).getUTCDate()"
                      @input="datepicked"></v-date-picker>
                  </v-dialog>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="grey lighten-3">
          <v-btn flat
            color="blue darken-2"
            @click="close">閉じる</v-btn>
          <v-spacer></v-spacer>
          <v-btn depressed color="blue darken-2" class="white--text"
            :disabled="!isValid"
            :loading="isLoading"
            @click="submit">追加する</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list-tile>
</template>

<script>
export default {
  name: 'insert-modal',
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false,
          searching: false
        },
        datepicker: {
          date: {
            data: '',
            status: false
          }
        }
      },
      meta: {
        certs: [
          '英検',
          'TOEIC',
          'TOEFL',
          'TOEFL iBT',
          'IELTS'
        ]
      },
      form: {
        name: '',
        score: '',
        date: '',
        note: ''
      },
      rules: {
        name: [
          v => !!v || '必須項目です'
        ],
        score: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    init: function () {
      this.$set(this, 'form', {
        valid: true,
        name: '',
        score: '',
        date: '',
        note: ''
      })
    },
    open: function () {
      this.init()
      this.$set(this.config.status, 'active', true)
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(this.$url.api + 'about/insert/meta', {
            cid: this.$route.params.id,
            mtype: 'about.cert',
            form: this.form
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$emit('emit', {
                action: 'insert',
                data: {
                  type: 'certs',
                  resolve: res.data.data
                }
              })
            }
            this.$set(this.config.status, 'loading', false)
            this.$set(this.config.status, 'active', false)
          })
        })
      }
    },
    datepick: function () {
      if (this.form.date.split('-').filter(it => isFinite(it)).length === 3) {
        this.$set(this.config.datepicker.date, 'data', this.form.date)
      }
      this.$set(this.config.datepicker.date, 'status', true)
    },
    datepicked: function () {
      this.$set(this.form, 'date', this.config.datepicker.date.data)
      this.$set(this.config.datepicker.date, 'status', false)
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isLoading () {
      return this.config.status.loading
    },
    isSearching () {
      return this.config.status.searching
    },
    printFormatedDate: {
      get: function () {
        if (this.form && this.form.date) {
          return (
            this.form.date.split('-').filter(it => isFinite(it)).length === 3
          ) ? this.$dateformat(this.form.date, 'yyyy/mm/dd', true) : this.form.date
        } else {
          return ''
        }
      },
      set: function (newValue) {
        this.$set(this.form, 'date', newValue)
      }
    },
    getCertItems () {
      return this.meta.certs
    }
  }
}
</script>
